import { template } from "@ember/template-compiler";
import styles from '@hokulea/core/actions.module.css';
import disabled from '../../modifiers/disabled';
import type { TOC } from '@ember/component/template-only';
import type { Importance, Importances, Intent, Intents, Spacing, Spacings } from '@hokulea/tokens';
export interface SubmitSignature {
    Element: HTMLButtonElement;
    Args: {
        intent?: Intent | Intents;
        importance?: Importance | Importances;
        spacing?: Spacing | Spacings;
        disabled?: boolean;
    };
    Blocks: {
        /** The label for the button */ default: [];
        /** The label for the button */ label: [];
        /** A slot in front of the label */ before: [];
        /** A slot after the label */ after: [];
    };
}
const Submit: TOC<SubmitSignature> = template(`
  <button
    type="submit"
    class={{styles.button}}
    data-intent={{if @intent @intent "action"}}
    data-importance={{if @importance @importance "supreme"}}
    data-spacing={{@spacing}}
    {{disabled when=(if @disabled @disabled false)}}
    data-test-button
    ...attributes
  >
    {{#if (has-block "before")}}
      <span data-test-button="before">
        {{yield to="before"}}
      </span>
    {{/if}}

    <span data-test-button="label">
      {{#if (has-block "label")}}
        {{yield to="label"}}
      {{/if}}

      {{#if (has-block)}}
        {{yield}}
      {{/if}}
    </span>

    {{#if (has-block "after")}}
      <span data-test-button="after">
        {{yield to="after"}}
      </span>
    {{/if}}
  </button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default Submit;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy8tcHJpdmF0ZS9mb3JtL2NvbXBvbmVudHMvc3VibWl0Lmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVzIGZyb20gJ0Bob2t1bGVhL2NvcmUvYWN0aW9ucy5tb2R1bGUuY3NzJztcblxuaW1wb3J0IGRpc2FibGVkIGZyb20gJy4uLy4uL21vZGlmaWVycy9kaXNhYmxlZCc7XG5cbmltcG9ydCB0eXBlIHsgVE9DIH0gZnJvbSAnQGVtYmVyL2NvbXBvbmVudC90ZW1wbGF0ZS1vbmx5JztcbmltcG9ydCB0eXBlIHsgSW1wb3J0YW5jZSwgSW1wb3J0YW5jZXMsIEludGVudCwgSW50ZW50cywgU3BhY2luZywgU3BhY2luZ3MgfSBmcm9tICdAaG9rdWxlYS90b2tlbnMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFN1Ym1pdFNpZ25hdHVyZSB7XG4gIEVsZW1lbnQ6IEhUTUxCdXR0b25FbGVtZW50O1xuICBBcmdzOiB7XG4gICAgaW50ZW50PzogSW50ZW50IHwgSW50ZW50cztcbiAgICBpbXBvcnRhbmNlPzogSW1wb3J0YW5jZSB8IEltcG9ydGFuY2VzO1xuICAgIHNwYWNpbmc_OiBTcGFjaW5nIHwgU3BhY2luZ3M7XG4gICAgZGlzYWJsZWQ_OiBib29sZWFuO1xuICB9O1xuICBCbG9ja3M6IHtcbiAgICAvKiogVGhlIGxhYmVsIGZvciB0aGUgYnV0dG9uICovXG4gICAgZGVmYXVsdDogW107XG5cbiAgICAvKiogVGhlIGxhYmVsIGZvciB0aGUgYnV0dG9uICovXG4gICAgbGFiZWw6IFtdO1xuXG4gICAgLyoqIEEgc2xvdCBpbiBmcm9udCBvZiB0aGUgbGFiZWwgKi9cbiAgICBiZWZvcmU6IFtdO1xuXG4gICAgLyoqIEEgc2xvdCBhZnRlciB0aGUgbGFiZWwgKi9cbiAgICBhZnRlcjogW107XG4gIH07XG59XG5cbmNvbnN0IFN1Ym1pdDogVE9DPFN1Ym1pdFNpZ25hdHVyZT4gPSA8dGVtcGxhdGU-XG4gIDxidXR0b25cbiAgICB0eXBlPVwic3VibWl0XCJcbiAgICBjbGFzcz17e3N0eWxlcy5idXR0b259fVxuICAgIGRhdGEtaW50ZW50PXt7aWYgQGludGVudCBAaW50ZW50IFwiYWN0aW9uXCJ9fVxuICAgIGRhdGEtaW1wb3J0YW5jZT17e2lmIEBpbXBvcnRhbmNlIEBpbXBvcnRhbmNlIFwic3VwcmVtZVwifX1cbiAgICBkYXRhLXNwYWNpbmc9e3tAc3BhY2luZ319XG4gICAge3tkaXNhYmxlZCB3aGVuPShpZiBAZGlzYWJsZWQgQGRpc2FibGVkIGZhbHNlKX19XG4gICAgZGF0YS10ZXN0LWJ1dHRvblxuICAgIC4uLmF0dHJpYnV0ZXNcbiAgPlxuICAgIHt7I2lmIChoYXMtYmxvY2sgXCJiZWZvcmVcIil9fVxuICAgICAgPHNwYW4gZGF0YS10ZXN0LWJ1dHRvbj1cImJlZm9yZVwiPlxuICAgICAgICB7e3lpZWxkIHRvPVwiYmVmb3JlXCJ9fVxuICAgICAgPC9zcGFuPlxuICAgIHt7L2lmfX1cblxuICAgIDxzcGFuIGRhdGEtdGVzdC1idXR0b249XCJsYWJlbFwiPlxuICAgICAge3sjaWYgKGhhcy1ibG9jayBcImxhYmVsXCIpfX1cbiAgICAgICAge3t5aWVsZCB0bz1cImxhYmVsXCJ9fVxuICAgICAge3svaWZ9fVxuXG4gICAgICB7eyNpZiAoaGFzLWJsb2NrKX19XG4gICAgICAgIHt7eWllbGR9fVxuICAgICAge3svaWZ9fVxuICAgIDwvc3Bhbj5cblxuICAgIHt7I2lmIChoYXMtYmxvY2sgXCJhZnRlclwiKX19XG4gICAgICA8c3BhbiBkYXRhLXRlc3QtYnV0dG9uPVwiYWZ0ZXJcIj5cbiAgICAgICAge3t5aWVsZCB0bz1cImFmdGVyXCJ9fVxuICAgICAgPC9zcGFuPlxuICAgIHt7L2lmfX1cbiAgPC9idXR0b24-XG48L3RlbXBsYXRlPjtcblxuZXhwb3J0IGRlZmF1bHQgU3VibWl0O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLFlBQVksbUNBQW1DO0FBRXRELE9BQU8sY0FBYywyQkFBMkI7QUFFaEQsY0FBYyxHQUFHLFFBQVEsaUNBQWlDO0FBQzFELGNBQWMsVUFBVSxFQUFFLFdBQVcsRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxRQUFRLFFBQVEsa0JBQWtCO0FBRW5HLGlCQUFpQjtJQUNmLFNBQVM7SUFDVDtRQUNFLFNBQVMsU0FBUztRQUNsQixhQUFhLGFBQWE7UUFDMUIsVUFBVSxVQUFVO1FBQ3BCLFdBQVcsT0FBTzs7SUFFcEI7UUFDRSw2QkFBNkIsR0FDN0I7UUFFQSw2QkFBNkIsR0FDN0I7UUFFQSxpQ0FBaUMsR0FDakM7UUFFQSwyQkFBMkIsR0FDM0I7OztBQUlKLE1BQU0sUUFBUSxJQUFJLG1CQUFtQixTQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQWlDL0MsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBO0FBRVYsZUFBZSxPQUFPIn0